/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_DescriptionInputs */

const en_homepage_hero_description = /** @type {(inputs: Homepage_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With voices that sound like an actual person speaking`)
};

const es_homepage_hero_description = /** @type {(inputs: Homepage_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con voces que suenan como una persona real hablando`)
};

/**
* | output |
* | --- |
* | "With voices that sound like an actual person speaking" |
*
* @param {Homepage_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_description = /** @type {((inputs?: Homepage_Hero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_description(inputs)
	return en_homepage_hero_description(inputs)
});